import React from 'react';

export const TsuCommentsModal = {
  title: 'Comments',
  body: (
    <div>
      <p>Description of the tsunami source event including damage, deaths, and comments on the accuracy of the report.</p>
      <p>
        For example, if the user is interested in tsunamis that include descriptions of effects to schools, enter the word
        {' '}
        <strong>school</strong>
        {' '}
        in the comments field.
      </p>
    </div>
  ),
};
